import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "../../constants/css/custom_styles.css";
import { HiHome, HiUserAdd } from "react-icons/hi";
import { GiEarthCrack, GiMedicines } from "react-icons/gi";
import { getUserRole } from "../../utils/localStoarege";
import { AiOutlineAppstore } from "react-icons/ai";
import { RiUser2Fill } from "react-icons/ri";
import { FaUserDoctor } from "react-icons/fa6";

const HudSidebar = () => {
  const location = useLocation();
  let isTab = useMediaQuery({ query: "(max-width: 768px)" });
  const [isOpen, setIsOpen] = useState(isTab ? false : true);

  const [isActive, setIsActive] = useState({
    home: false,
    hud_machines: false,
    hud_patients: false,
    hud_add: false,
    hud_medicines: false,
    doctor: false,
    patients: false,
  });

  useEffect(() => {
    setIsOpen(!isTab);
  }, [isTab]);

  useEffect(() => {
    const path = location.pathname;

    setIsActive({
      home: path === "/home",
      hud_machines: path.includes("/hud-machines"),
      hud_patients: path.includes("/hud-patients") && path !== "/hud-patients/add",
      hud_add: path === "/hud-patients/add",
      hud_medicines: path.includes("/hud-medicines"),
      doctor: path === "/hud-doctor-view",
      patients: path.includes("/hud-patients"),
    });
  }, [location.pathname]);

  const handleIsActive = (key) => {
    setIsActive((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return (
    <motion.div
      initial={{ x: -250 }}
      animate={{ x: isOpen ? 0 : -250 }}
      className="bg-secondary text-[#ffffff] shadow-xl w-[10rem] max-w-[10rem] h-full md:overflow-y-scroll 2xl:overflow-hidden md:relative  fixed pl-2"
    >
      <div className="flex flex-col justify-between h-full text-xs">
        <div
          className={`text-xs whitespace-pre pb-2 pt-4 flex flex-row gap-2 font-bold ${isOpen ? "block" : "hidden"}`}
        >
          <HiHome size={18} />
          HUD
        </div>
        <hr className="border-white my-2" />
        <div className="overflow-y-auto flex-1">
          {/* Menus */}
          <div className="flex flex-col h-full">
            {/* First */}
            <ul className="whitespace-pre px-2.5 text-[0.9rem] py-3 flex flex-col gap-2 font-medium scrollbar-thin h-full md:h-full">
              {<li>
                <NavLink
                  to="/home"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.home ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("home")}
                >
                  <AiOutlineAppstore size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Dashboard
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/hud-patients/add"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_add ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_add")}
                >
                  <HiUserAdd size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Add Patient
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/hud-patients"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_patients ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_patients")}
                >
                  <RiUser2Fill size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Patients
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/hud-doctor-view"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.doctor ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("doctor")}
                >
                  <FaUserDoctor size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Doctor's View
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/hud-machines"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_machines ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_machines")}
                >
                  <GiEarthCrack size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Machines
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/hud-medicines"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_medicines ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_medicines")}
                >
                  <GiMedicines size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Medicines
                  </p>
                </NavLink>
              </li>}
            </ul>
          </div>

        </div>
        <p className="text-[0.5rem] mb-4">
          <Link to={getUserRole() === "developer" ? "/hud-developer" : null}>
            © Developed By: Rashail Tech. Labs
          </Link>
        </p>
      </div>
    </motion.div>
  );
};

export default HudSidebar;
